import React from "react";
import { Link } from "react-router-dom";
import Api from "../../servicios/api";
import Swal from 'sweetalert2';

class Editar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosCargados: false,
      nombre: "",
      tipo: "",
      enfermedad: [],
      errores: []
    };
  }
  cambioValor = (e) => {
    const state = this.state.enfermedad;
    state[e.target.name] = e.target.value;
    this.setState({ enfermedad: state });
  };
  verificarError(elemento) {
    return this.state.errores.indexOf(elemento) !== -1;
  }
  enviarDatos = (e) => {
    e.preventDefault();
    console.log("Formulario Enviado...");
    // const {nombre_atencion, tipo,id_atencion,codigo_atencion,cuenta} = this.state.empleado;
    let form = document.getElementById('form');
    let formData = new FormData(form);
    console.log(formData);
    //var datosEnviar = {nombre:nombre_atencion, tipo:tipo,id:id_atencion,cuenta:cuenta,codigo:codigo_atencion}
    fetch(Api + "UpEnfermedad", {
      method: "POST",
      body: formData
    })
      .then(respuesta => respuesta.json())
      .then((datosRespuesta) => {
        console.log(datosRespuesta)
        Swal.fire(
          'Enfermedad!',
          datosRespuesta.msj,
          'success'
        )
        this.props.history.push("/MasterEnfermedades");
      })
      .catch(console.log)
  }
  componentDidMount() {
    console.log(this.props.match.params.id);
    fetch(Api + "Enfermedades/" + this.props.match.params.id,
      {
        method: "GET",
        headers: new Headers({
          'Authorization': 'koala2021'
        }),
      })
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        console.log(datosRespuesta);
        this.setState({ datosCargados: true, enfermedad: datosRespuesta }); //
      })
      .catch(console.log);
  }
  render() {
    const { datosCargados, enfermedad } = this.state;
    if (!datosCargados) {
      var load = 'Cargando datos....';
    } else {
      var load = '';
    }
    return (
      <div>
        <div className="content-wrapper">
          <div className="content">
            <div className="container-fluid">
              <br />
              <div className="card">
                <div className="card-header">
                  {
                    load ? (
                      load
                    ) : (
                      "Editar Enfermedad"
                    )
                  }
                </div>
                <div className="card-body">
                  <form onSubmit={this.enviarDatos} id="form">
                    <div className="form-group">
                      <label htmlFor="id">Id :</label>
                      <input
                        type="text"
                        name="id"
                        id="id"
                        value={enfermedad.id_enfermedad}
                        className="form-control form-control-sm"
                        placeholder=""
                        aria-describedby="helpId"
                        onChange={this.cambioValor}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="codigo">Código:</label>
                      <input
                        type="text"
                        name="codigo"
                        id="codigo"
                        defaultValue={enfermedad.codigo_enf}
                        className={((this.verificarError("error_codigo")) ? "is-invalid" : "") + " form-control form-control-sm"}
                        onChange={this.cambioValor}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="nombre">Nombre:</label>
                      <input
                        type="text"
                        name="nombre"
                        id="nombre"
                        defaultValue={enfermedad.descripcion}
                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"}
                        onChange={this.cambioValor}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="tipo">Sexo:</label>
                      <select name="tipo"
                        id="tipo"
                        value={enfermedad.sexo}
                        options={enfermedad.sexo}
                        className={((this.verificarError("error_tipo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                        onChange={this.cambioValor}>
                        <option value="">Seleccione el Sexo</option>
                        <option value="A">Ambos</option>
                        <option value="F">Femenino</option>
                        <option value="M">Masculino</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="forma">Límite Inferior:</label>
                      <input
                        type="text"
                        name="forma"
                        id="forma"
                        defaultValue={enfermedad.lim_inf}
                        className={((this.verificarError("error_forma")) ? "is-invalid" : "") + " form-control form-control-sm"}
                        onChange={this.cambioValor}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="cuenta">Límite Superior:</label>
                      <input
                        type="text"
                        name="cuenta"
                        id="cuenta"
                        defaultValue={enfermedad.lim_sup}
                        onChange={this.cambioValor}
                        className={((this.verificarError("error_cuenta")) ? "is-invalid" : "") + " form-control form-control-sm"}
                      />
                    </div>
                    <br />
                    <div className="btn-group" role="group" aria-label="">
                      <button type="submit" className="btn btn-warning btn-sm">
                        Editar
                      </button>&nbsp;&nbsp;
                      <Link className="btn btn-danger btn-sm" to={"/MasterEnfermedades"}>
                        Cancelar
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Editar;
